import styled from 'styled-components';

import colors from '../../../../../../../../styles/colors';

const CommunitySection = styled.div`
  margin-bottom: 20px;
`;

const CommunityHint = styled.div`
  font-size: 12px;
  color: ${colors.shades.gamma10};
  margin: 4px 0 8px;
`;

const CommunityCreateBox = styled.div`
  border: 1px solid ${colors.shades.gamma13};
  border-radius: 10px;
  padding: 12px;
  margin-top: 8px;
`;

const CommunityCreateActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
`;

export {
  CommunitySection,
  CommunityHint,
  CommunityCreateBox,
  CommunityCreateActions,
};
